<template lang="pug">
.container
  gb-side-menu
  .content-area
    div(style="display:flex;justify-content:space-between")
      h3 管理者一覧
      gb-button(@clicked="openAddModal").effect 追加
    member-list-manager(
      :memberList="memberList"
      @clickEdit="openEditModal"
      @clickDelete="openDeleteModal"
    )
    template(v-if="showAdd")
      gb-mask(:show="true")
        .gb-card-cancel.edit-cards
          .cancel-box(@click="closeModal")
            p.cancel-bottom ×
          gb-input(label="氏名" v-model="adminUserName" style="margin:auto;")
          gb-input(label="氏名（カナ）" v-model="adminUserNameKana" style="margin:auto;")
          gb-input(label="メールアドレス" v-model="adminUserEmail" style="margin:auto;")
          gb-input(label="パスワード" type="password" v-model="adminUserPassword" style="margin:auto;")
          .radio-wrapper(style="margin-right:90px;")
            label.label 保育士一覧の閲覧
            div(style="display:flex; margin:10px 0")
              label.publish-label(:class="{ 'publish-label-active' :canShowChildminderList }", @click="setInterview('canShowChildminderList', true)") 可能
              label.publish-label(:class="{ 'publish-label-active' :!canShowChildminderList }", @click="setInterview('canShowChildminderList', false)") 不可能
            label.label れんらくノートの閲覧
            div(style="display:flex; margin:10px 0")
              label.publish-label(:class="{ 'publish-label-active' :canShowCommunicationNotebook }", @click="setInterview('canShowCommunicationNotebook', true)") 可能
              label.publish-label(:class="{ 'publish-label-active' :!canShowCommunicationNotebook }", @click="setInterview('canShowCommunicationNotebook', false)") 不可能
            label.label 管理者情報の閲覧
            div(style="display:flex; margin:10px 0")
              label.publish-label(:class="{ 'publish-label-active' :canShowAdminUserInfo }", @click="setInterview('canShowAdminUserInfo', true)") 可能
              label.publish-label(:class="{ 'publish-label-active' :!canShowAdminUserInfo }", @click="setInterview('canShowAdminUserInfo', false)") 不可能
            label.label 管理者情報の編集
            div(style="display:flex; margin:10px 0")
              label.publish-label(:class="{ 'publish-label-active' :canEditAdminUserInfo }", @click="setInterview('canEditAdminUserInfo', true)") 可能
              label.publish-label(:class="{ 'publish-label-active' :!canEditAdminUserInfo }", @click="setInterview('canEditAdminUserInfo', false)") 不可能
          .button-wrapper
            gb-button.primary(@clicked="createAdminUser" style="width:400px;") 追加

    template(v-if="showEdit")
      gb-mask(:show="true")
        .gb-card-cancel.edit-cards
          .cancel-box(@click="closeModal")
            p.cancel-bottom ×
          gb-input(label="氏名" v-model="adminUserName" style="margin:auto;")
          gb-input(label="氏名（カナ）" v-model="adminUserNameKana" style="margin:auto;")
          .radio-wrapper(style="margin-right:90px;")
            label.label 保育士一覧の閲覧
            div(style="display:flex; margin:10px 0")
              label.publish-label(:class="{ 'publish-label-active' :canShowChildminderList }", @click="setInterview('canShowChildminderList', true)") 可能
              label.publish-label(:class="{ 'publish-label-active' :!canShowChildminderList }", @click="setInterview('canShowChildminderList', false)") 不可能
            label.label れんらくノートの閲覧
            div(style="display:flex; margin:10px 0")
              label.publish-label(:class="{ 'publish-label-active' :canShowCommunicationNotebook }", @click="setInterview('canShowCommunicationNotebook', true)") 可能
              label.publish-label(:class="{ 'publish-label-active' :!canShowCommunicationNotebook }", @click="setInterview('canShowCommunicationNotebook', false)") 不可能
            label.label 管理者情報の閲覧
            div(style="display:flex; margin:10px 0")
              label.publish-label(:class="{ 'publish-label-active' :canShowAdminUserInfo }", @click="setInterview('canShowAdminUserInfo', true)") 可能
              label.publish-label(:class="{ 'publish-label-active' :!canShowAdminUserInfo }", @click="setInterview('canShowAdminUserInfo', false)") 不可能
            label.label 管理者情報の編集
            div(style="display:flex; margin:10px 0")
              label.publish-label(:class="{ 'publish-label-active' :canEditAdminUserInfo }", @click="setInterview('canEditAdminUserInfo', true)") 可能
              label.publish-label(:class="{ 'publish-label-active' :!canEditAdminUserInfo }", @click="setInterview('canEditAdminUserInfo', false)") 不可能
          .button-wrapper
            gb-button.primary(@clicked="updateAdminMast" style="width:400px;") 変更
    transition(name="fade")
      template(v-if="showDelete")
        gb-mask(:show="true")
          .gb-card-cancel.edit-wrapper
            .cancel-box(@click="closeModal")
              p.cancel-bottom ×
            h3.delete-text 管理者情報を削除しますか？
            .button-wrapper(style="margin-top:100px;")
              gb-button.danger(@clicked="deleteAdminMast" style="width:300px;") OK
</template>
<script>
import util from '@/api/util'
import { VueLoading } from 'vue-loading-template'
import LocalDataUtil from '@/util/LocalDataUtil.js'
import _ from 'lodash'

import MemberListManager from '@/components/organisms/MemberListManager.vue'
import GbSideMenu from '@/components/organisms/GbSideMenu.vue'
import GbButton from '@/components/atoms/GbButton.vue'
import GbInput from '@/components/atoms/GbInput.vue'
import GbMask from '@/components/atoms/GbMask.vue'
import GbCard from '@/components/atoms/GbCard.vue'

export default {
  components: {
    VueLoading,
    MemberListManager,
    GbSideMenu,
    GbButton,
    GbInput,
    GbMask,
    GbCard
  },
  data () {
    return {
      showEdit: false,
      showDelete: false,
      showAdd: false,
      adminUserName: '',
      adminUserNameKana: '',
      adminUserEmail: '',
      adminUserPassword: '',
      memberList: [],
      selectedMemberData: null,
      canShowChildminderList: false,
      canShowCommunicationNotebook: false,
      canShowAdminUserInfo: false,
      canEditAdminUserInfo: false,
      accessNursery: null,
      noAccessNursery: null,
      editAdmin: null
    }
  },
  beforeMount: async function () {
    const isMaintenance = (await util.checkMaintenance({type: 'admin'})).data.data.is_maintenance
    if (isMaintenance) {
      this.$swal.fire({
        html: `現在メンテナンス中です`
      }).then(() => {
        this.$router.push({ name: 'Maintenance' })
      })
    } else {
      util.createMethod('COG', 'checkSessionExpired', null)
        .then(response => {
          if (response) {
            this.$router.push({ name: 'SignIn' })
          } else {
            this.fetchAdminMastList()
          }
        })
    }
  },
  methods: {
    async fetchAdminMastList () {
      const Authority = (await util.createMethod('APPSYNC', 'fetchAdminMast', {sub: LocalDataUtil.getSub()}))
      if (!Authority.getAdmin) {
        this.$swal.fire({
          text: `管理者情報の閲覧権限がありません`
        }).then(() => {
          this.$router.push({ name: 'SchoolList' })
        })
        return
      }
      const Response = _.orderBy((await util.createMethod('APPSYNC', 'fetchAdminMastList', null)).items, ['name'], ['asc'])
      this.memberList = Response.filter(v => !v.isDeleted)
    },
    setInterview (key, bool) {
      if (key === 'canShowChildminderList') {
        this.canShowChildminderList = bool
      } else if (key === 'canShowCommunicationNotebook') {
        this.canShowCommunicationNotebook = bool
      } else if (key === 'canShowAdminUserInfo') {
        this.canShowAdminUserInfo = bool
      } else if (key === 'canEditAdminUserInfo') {
        this.canEditAdminUserInfo = bool
      }
    },
    async openEditModal (member) {
      const Authority = (await util.createMethod('APPSYNC', 'fetchAdminMast', {sub: LocalDataUtil.getSub()}))
      if (Authority.editAdmin === false) {
        this.$swal.fire({text: `管理者情報の編集が許可されていません`})
        return
      }
      this.selectedMemberData = member
      this.adminUserName = this.selectedMemberData.name
      this.adminUserNameKana = this.selectedMemberData.name_kana
      this.canShowChildminderList = this.selectedMemberData.getChildminder
      this.canShowCommunicationNotebook = this.selectedMemberData.getRecord
      this.canShowAdminUserInfo = this.selectedMemberData.getAdmin
      this.canEditAdminUserInfo = this.selectedMemberData.editAdmin
      this.showEdit = true
    },
    updateAdminMast () {
      const APPSYNC_REQUEST_VALUE = {
        sub: this.selectedMemberData.sub,
        name: this.adminUserName,
        name_kana: this.adminUserNameKana,
        getChildminder: this.canShowChildminderList,
        getRecord: this.canShowCommunicationNotebook,
        editAdmin: this.canEditAdminUserInfo,
        getAdmin: this.canShowAdminUserInfo
      }
      util.createMethod('APPSYNC', 'updateAdminMast', APPSYNC_REQUEST_VALUE)
        .then(() => {
          this.$swal.fire({
            text: `管理者情報を変更しました`
          }).then(() => {
            this.closeModal()
          })
        })
        .catch(() => {
          let dialog = `エラーが発生しました<br>時間をおいてもう一度お試しください`
          this.$swal.fire({html: `${dialog}`})
        })
    },
    openDeleteModal (member) {
      this.selectedMemberData = member
      this.showDelete = true
    },
    deleteAdminMast () {
      const APPSYNC_REQUEST_VALUE = {
        sub: this.selectedMemberData.sub,
        name: this.selectedMemberData.name,
        name_kana: this.selectedMemberData.name_kana,
        getChildminder: this.selectedMemberData.getChildminder,
        getRecord: this.selectedMemberData.getRecord,
        editAdmin: this.selectedMemberData.editAdmin,
        getAdmin: this.selectedMemberData.getAdmin,
        isDeleted: true
      }
      util.createMethod('APPSYNC', 'updateAdminMast', APPSYNC_REQUEST_VALUE)
        .then(() => {
          this.$swal.fire({
            text: `削除が完了しました`
          }).then(() => {
            this.closeModal()
          })
          this.fetchAdminMastList()
        })
        .catch(() => {
          let dialog = `エラーが発生しました<br>時間をおいてもう一度お試しください`
          this.$swal.fire({html: `${dialog}`})
        })
    },
    openAddModal () {
      this.showAdd = true
    },
    async createAdminUser () {
      if (this.user_name === '' || this.user_name === null) {
        this.$swal.fire({html: `氏名を入力してください`})
        return
      } else if (this.user_name_kana === '' || this.user_name_kana === null) {
        this.$swal.fire({html: `氏名（カナ）を入力してください`})
        return
      } else if (this.adminUserEmail === '' || this.adminUserEmail === null) {
        this.$swal.fire({html: `メールアドレスを入力してください`})
        return
      } else if (this.adminUserPassword === '' || this.adminUserPassword === null || this.adminUserPassword.length < 6) {
        this.$swal.fire({html: `パスワードを6文字以上で入力してください`})
        return
      }
      try {
        // Cognitoでサインアップ処理を行なったのちにdynamoに追加
        const COG_REQUEST_VALUE = {
          username: this.adminUserEmail,
          password: this.adminUserPassword,
          attributes: {
            name: this.adminUserName,
            nickname: this.adminUserNameKana
          }
        }
        const COG_RESPONSE = (await util.createMethod('COG', 'signUp', COG_REQUEST_VALUE))
        if (!COG_RESPONSE) throw new Error('エラーが発生しました<br>時間をおいてもう一度お試しください')
        const APPSYNC_REQUEST_VALUE = {
          sub: COG_RESPONSE.userSub,
          name: this.adminUserName,
          name_kana: this.adminUserNameKana,
          getChildminder: this.canShowChildminderList,
          getRecord: this.canShowCommunicationNotebook,
          editAdmin: this.canEditAdminUserInfo,
          getAdmin: this.canShowAdminUserInfo,
          isDeleted: false
        }
        const APPSYNC_RESPONSE = (await util.createMethod('APPSYNC', 'createAdminMast', APPSYNC_REQUEST_VALUE))
        if (!APPSYNC_RESPONSE) throw new Error('エラーが発生しました<br>時間をおいてもう一度お試しください')
        this.fetchAdminMastList()
        this.$swal.fire({
          html: `メールを確認して登録を完了させてください`
        }).then(() => {
          this.closeModal()
        })
      } catch (error) {
        if (error.code === 'UsernameExistsException') {
          this.$swal.fire({html: `登録されたことのあるメールアドレスは再登録できません<br><br>再登録する場合は管理者にお問い合わせください`})
        } else if (error.message) {
          this.$swal.fire({html: `${error.message}`})
        } else {
          let dialog = `エラーが発生しました<br>時間をおいてもう一度お試しください`
          this.$swal.fire({html: `${dialog}`})
        }
      }
    },
    closeModal () {
      this.adminUserName = ''
      this.adminUserNameKana = ''
      this.canShowChildminderList = false
      this.canShowCommunicationNotebook = false
      this.canShowAdminUserInfo = false
      this.canEditAdminUserInfo = false
      this.showEdit = false
      this.showDelete = false
      this.showAdd = false
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '../stylus/main.styl';
.container
  width 100vw
  height 100vh
  display flex
  flex-direction row
.labels {
  margin: 5px;
  border: 1px solid #006DD9;
}
.col-group {
  display: flex;
  flex-direction: column;
}

.edit-wrapper {
  width: 680px;
  height: 400px;
  display: flex;
  flex-direction: column;
}
.edit-cards
  margin auto
  padding 30px
  display flex
  width 680px
  flex-direction column
  background-color white

.gb-card-cancel {
  background-color: #fff;
  border-radius: 2px;
  padding-top: 0;
  padding-right: 0;
  align-items: flex-end;
}

.button-wrapper
  margin 30px auto 20px

.cancel-box {
  cursor pointer
  width: 50px;
  height: 50px;
  border-bottom: 1px solid #000;
  border-left: 1px solid #000;
  display: grid;
  align-items: center;
}

.cancel-bottom {
  font-size: 30px;
  text-align: center;
  font-weight: 300;
}

.publish-label-container {
  padding: 1rem;
  text-align: center;
}

.publish-label {
  font-size: 1rem;
  padding: 0.5rem 2rem;
  margin: 0 3.5rem;
  border: 2px solid #e0e0e0;
  color: #e0e0e0;
  border-radius: 1rem;
}

.radio-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  margin: 16px 0;
}

.label {
  font-size: 12px;
  color: $color-secondary;
  margin: 0 8px;
}
.publish-label-active {
  border: 2px solid #EA847A;
  color: #EA847A;
}
.delete-text
  margin 100px auto 0
.confirm-text
  margin 20px auto 0
</style>



// WEBPACK FOOTER //
// src/views/ManagerList.vue